import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormDataStoreService {
  private readonly store = new Map<string, unknown>();

  setFormData<T>(key: string, data: T): void {
    this.store.set(key, data);
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getFormData<T = unknown>(key: string): T | null {
    if (this.store.has(key)) {
      return this.store.get(key) as T;
    }

    // → fallback to sessionStorage if map was empty:
    const json = sessionStorage.getItem(key);
    return json ? JSON.parse(json) as T : null;
  }

  clearFormData(key: string): void {
    this.store.delete(key);
    sessionStorage.removeItem(key);
  }

  clearAllFormData(): void {
    this.store.clear();
    sessionStorage.clear();
  }

  subscribeToForm<T>(key: string, form: FormGroup, destroyRef: DestroyRef, debounceMs: number = 100): void {
    const savedData = this.getFormData<T>(key);
    if (savedData) {
      form.patchValue(savedData);
    }

    form.valueChanges.pipe(debounceTime(debounceMs), takeUntilDestroyed(destroyRef)).subscribe(value => {
      this.setFormData(key, value as T);
    });
  }
}